<script>
import store from '../store/index.js';
import {reduce} from 'lodash';
import {getTimeStr} from '../../../../common/util';
export default {
    data() {
        return {
            title: store.information.title,
			moreFlag: false,
			showCard: false,
			limitNum: 5
        }
	},
	computed: {
		list() {
			return store.information.list;
		}

	},
	mounted() {
	},
	watch: {
		list: {
			handler(v) {
				if(v && v.length) {
					if(v.length > this.limitNum) {
						this.moreFlag = true;
					} else if(v.length) {
						this.moreFlag = false;
					}
					if(v[0].title && v[0].publishTime) {
						this.showCard = true;
					}
					// 添加咨询文章曝光点击
					this.$nextTick(() => {
						this.addMointor();
					})
				} else {
					this.showCard = false;
				}
			},
			immediate: true
		}
	},
	methods: {
		more() {
			this.moreFlag = false;
			this.limitNum = this.list.length;
		},
		addMointor() {
			this.$clickMonitor.update(reduce(document.querySelectorAll('.information-article'), (arr, el) => {
				const callback = function (params) {
					const index = params.options.el.getAttribute('data-index');
					const buttonId = `information-${+index + 1}-${params.monitor.status}`;
					return {
						buttonId,
						...store.getClickMonitorParams()
					};
				};
				arr.push({el, event: 'expose', callback});
				arr.push({el, event: 'click', callback});
				return arr;
			}, []));
		},
		formatDate(time) {
			if (getTimeStr(time).indexOf('N') !== 0) {
				return getTimeStr(time);
			} else {
				return time.substring(0, 10)
			}
			
		},
		jumpArticle(card){
			window.open(card.mjumpUrl);
		},
		getTitlle(title) {
			if(title && title.length > 20) {
				return title.substring(0, 20)+'...';
			} else {
				return title;
			}
		}
	}
}
</script>

<template>
    <div  class="wrap" v-show="showCard">
        <div class="title">
        	{{title}}
        </div>
        <div class="main">
			<div class="card-wrap" v-if="list.length">
				<a class="card information-article" :data-index="index" v-for="(card, index) in list" v-show="index < limitNum" :key="card.src" target="blank" @click="jumpArticle(card)">
					
					<div class="card-text" :class="{'card-text2': !card.imgUrl}">
						<div class="card-title">{{card.title}}</div>
						<div class="card-date">{{formatDate(card.publishTime)}}</div>
					</div>
					<div class="card-img" v-if="card.imgUrl" :style="{'background-image': 'url('+card.imgUrl+')'}">
					</div>
				</a>
				<div class="more-wrap" v-if="moreFlag"  @click="more">
					<span class="moreText">查看更多</span>
				</div>
			</div>
        </div>
    </div>
</template>
<style lang="stylus" scoped>
.wrap
	margin-bottom .5rem
.title
	margin 0.5rem auto
	position relative
	width 6.72rem
	text-indent 2rem
	&:before
		content ''
		position absolute
		left 0.7rem
		top .3rem
		width 1.07rem
		height 1.01rem
		background url("../../assets/title_zx_bg.svg")
		background-size 100%
	&:after
		content ''
		display inline-block
		position absolute
		left 0
		bottom -0.05rem
		width 100%
		height 0.11rem
		background url("../../assets/title_line.png") top left no-repeat
		background-size 100%
.main
	border-radius 4px
	padding 0 0.53rem
	background #fff
	z-index: 3;
.card-wrap
	background: #fff
	margin: 0 -1px
	.more-wrap
		padding 0.3rem 0
		text-align center
	.moreText
		cursor pointer
		display inline-block
		font-size 0.625rem
		line-height 1rem
		color #999
		&:after {
			content ''
			display inline-block
			border-bottom 1px solid #ddd
			border-right 1px solid #ddd
			width 0.4375rem
			height 0.4375rem
			position relative
			left .3rem
			top -.1rem
			transform rotate(45deg)
		}
.card {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 1.06rem 0;
        border-bottom: 1px solid #EBEBEB;
		text-decoration: none;
    }
.card-text {
	width: 9.375rem;
	height: 4.1875rem;
	display: flex;
	flex-direction: column;
	line-height: 1.0625rem;
	font-size: 0.75rem;
	justify-content: space-between;
	text-align: left;
	color: #333;
	text-decoration: none;
	.card-title {
		height 2.18rem;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
}
.card-text2 {
	width: auto;
    height: 3.5rem;
}
.card-date {
	font-size:0.64rem;
	color: #666;
}
.card-img {
	width: 6.3125rem;
	height: 4.1875rem;
	overflow: hidden;
	background-position:center center;
	background-repeat: no-repeat;
	background-size: cover;
	border-radius: 0.11rem;
}
.more-wrap{
	padding: 0.3rem 0;
	text-align: center;
}
.moreText{
	cursor: pointer;
	display: inline-block;
	font-size: 0.625rem;
	line-height: 1rem;
	color: #999;
}
.moreText:after {
	content: '';
	display: inline-block;
	border-bottom: 1px solid #ddd;
	border-right: 1px solid #ddd;
	width: 0.4375rem;
	height: 0.4375rem;
	position: relative;
	left: .3rem;
	top: -.1rem;
	transform: rotate(45deg);
}
</style>